export default __webpack_public_path__ + "static/media/photo1.1c3bba45.png";